import React from 'react';

import DateComponent from 'src/components/DateComponent';
import Icon from 'src/components/Icon';
import TextTooltip from 'src/components/TextTooltip';
import { getAuditActivityMetadata, getAuditWindowFallbackLabel } from 'src/utils/auditActivityMetadata';
import * as variables from 'src/styles/variables';
import styles from './styles.module.scss';

/**
 * The LAST LOGGED IN and LAST ACTIVITY cells, shared by the Users and AdminUsers tables. Both tables
 * had their own byte-identical copy of each renderer. The API bounds the audit reads that feed these
 * columns, so an empty date now needs a reason rather than a bare dash, and that wording should not
 * live in four places.
 */
export interface AuditActivityCellUser {
    lastLoginDttm?: string | null;
    lastActivityDttm?: string | null;
    lastActivityType?: string | null;
    activityWindowDays?: number | null;
}

export const LastLoginCell = ({ user }: { user: AuditActivityCellUser }) => {
    if (!user.lastLoginDttm) {
        return <span>{getAuditWindowFallbackLabel('login', user.activityWindowDays)}</span>;
    }

    return <DateComponent date={user.lastLoginDttm} showDateTime={true} useBrowserTimeZone />;
};

export const LastActivityCell = ({ user }: { user: AuditActivityCellUser }) => {
    if (!user.lastActivityDttm) {
        return <span>{getAuditWindowFallbackLabel('activity', user.activityWindowDays)}</span>;
    }

    const activityMetadata = getAuditActivityMetadata(user.lastActivityType);
    return (
        <div className={styles.activityCell}>
            <TextTooltip text={activityMetadata.label}>
                <Icon className={styles.activityIcon} name={activityMetadata.icon} size={16} color={variables.grey} />
            </TextTooltip>
            <DateComponent date={user.lastActivityDttm} showDateTime={true} useBrowserTimeZone />
        </div>
    );
};
